import type { ConversationDetailAllOfThreeMessagesItem } from './conversationDetailAllOfThreeMessagesItem';

export type ConversationDetailAllOfThree = {
  /** 대화 전체 메시지 목록 */
  messages?: ConversationDetailAllOfThreeMessagesItem[];
};
